import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import Footer from '../components/footer';
import ViewerPanel from './viewerPanel';
import { withLinkStore, ACTION_TYPES_CREATING_SESSION } from '../app/reducers';
import Player from './playerWrapper';
import { isMobilePhone, isMobileDevice, isShowSignature, isAudioVideoFirestorm } from '../commonUtil/util';
import { isMobile as isMobileReponsive } from '../commonUtil/responsiveUtil';
import CustomFooter from './customFooter';
import ApplicationEntity from '../commonUtil/appEntity';
import { createSessionBusiness } from '../commonUtil/sessionBusiness';
import { setUniqueInteractionCookie, getUniqueInteractionCookie } from '../commonUtil/cookieUtil';
import { events } from '../commonUtil/humanDetect';
import handleGotoPage from '../commonUtil/gotoPageHandler';

const LinkViewer = (props) => {
    const { contents, sender, selectedContent, hasCustomFooter, linkBasicInfo, creatingSession, selectedManifest, isOnlyFunctionalCookies, isStrictlyNecessaryCookies } = props.linkStore;
    const { universalPlayerEvent } = props.linkStore;
    const [showFooter, setShowFooter] = useState(false);
    const [isLikelyHuman, setLikelyHuman] = useState(false);

    const isMultiContent = contents.length > 1;
    const isExpired = linkBasicInfo && linkBasicInfo.isExpired;

    const onSelectContent = (content) => {
        setShowFooter(false);
        props.onSelectContent(content);
    };

    const hideFooter = () => {
        if (showFooter) {
            setShowFooter(false);
        }
    };

    const createSession = async () => {
        const [error, sessionId] = await createSessionBusiness(isExpired, isOnlyFunctionalCookies, isStrictlyNecessaryCookies, props.linkDispatch);
        if (sessionId) {
            handleGotoPage(universalPlayerEvent, { isExpired, isOnlyFunctionalCookies: false });
        } else {
            console.log(error);
        }
    };

    useEffect(() => {
        const isHuman = () => {
            setLikelyHuman(true);
            events.forEach(name => window.removeEventListener(name, isHuman, true));
        };

        if (!getUniqueInteractionCookie()) {
            events.forEach(name => window.addEventListener(name, isHuman, true));
        }
    }, []);

    useEffect(() => {
        if (isLikelyHuman && !ApplicationEntity.getInstance().sessionId) {
            setUniqueInteractionCookie();
            createSession();
        }
    }, [isLikelyHuman]);

    useEffect(() => {
        if (!ApplicationEntity.getInstance().sessionId) {
            createSessionBusiness(isExpired, isOnlyFunctionalCookies, isStrictlyNecessaryCookies, props.linkDispatch);
        } else {
            props.linkDispatch({ type: ACTION_TYPES_CREATING_SESSION, payload: false });
        }
    }, []);

    const displayFooter = (footerVisiable) => {
        const isShowByAnonymous = (sender.isAnonymousSender && isMultiContent) || !sender.isAnonymousSender;
        const isShow4Signature = isShowSignature();
        if (footerVisiable && !showFooter && isShowByAnonymous && ((!isShow4Signature && isMultiContent) || isShow4Signature)) {
            if ((!isMobilePhone() && !isMobileReponsive()) || !isMultiContent || (!isMobileDevice.any())) {
                setShowFooter(true);
            }
        } else {
            setShowFooter(false);
        }
    };

    const shouldHideFooter = isAudioVideoFirestorm(selectedManifest);
    const contianerClass = classnames('seismic-engagement-viewer-with-footer',
        { 'panel-opened': props.openPanel },
        { '-multi-footer': (showFooter && !shouldHideFooter && isMultiContent) },
        { '-single-footer': (showFooter && !shouldHideFooter && !isMultiContent) });

    return (
        <div className="seismic-engagement-viewer-content">
            {selectedContent.id && <div key="SeismicViewerWithFooter" className={contianerClass}>
                <div role="main" aria-label="Content Viewer" className="seismic-engagement-player">
                    <div id="playerContainer" className="player-container" onClick={hideFooter}>
                        {creatingSession && <div className="engagement-viewer-busy-spinner" />}
                        {!creatingSession && <Player displayFooter={displayFooter} />}
                    </div>
                </div>
                <Footer
                    hideFooter={hideFooter}
                    isOpen={props.openPanel}
                    showFooter={showFooter}
                    onSelectContent={onSelectContent} />
                {hasCustomFooter && <CustomFooter />}
            </div>}
            <ViewerPanel
                key="ViewerPanel"
                isOpen={props.openPanel}
                setOpenPanel={props.setOpenPanel}
                onSelectContent={onSelectContent} />
        </div>
    );
};

export default withLinkStore(LinkViewer);
